document.querySelectorAll('[data-sg-preview-form]').forEach(form => {
 if (form.dataset.ready) return;
 form.dataset.ready = 'true';
 form.addEventListener('submit', event => {
  event.preventDefault();
  if (!form.reportValidity()) return;
  const fields = Array.from(new FormData(form).entries()).map(([name,value]) => name + ': ' + String(value).trim());
  const blanket = form.querySelector('[name="Blanket colour"]');
  fields.splice(3, 0, 'Blanket colour supplier code: ' + blanket.selectedOptions[0].dataset.supplierCode);
  const body = 'Please create an illustrative preview of the baby’s name on this blanket.\n\n' + fields.join('\n') + '\n\nI understand this is a visual guide and does not place an order.';
  const result = form.parentElement.querySelector('[data-sg-email-result]');
  result.querySelector('[data-sg-prepared-request]').value = body;
  result.querySelector('[data-sg-mail-link]').href = 'mailto:stitchandgrowcontact@gmail.com?subject=' + encodeURIComponent('Baby name preview request') + '&body=' + encodeURIComponent(body);
  result.hidden = false;
  result.scrollIntoView({block:'start',behavior:'smooth'});
 });
});
